// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * QR 스티커 출력 페이지 - 가로 2분할 레이아웃
 * 좌: QR 카메라 스캐너 (40%) / 우: 전화번호 + 가족 + 로그 (60%)
 */

/* ─── 전체 레이아웃 ─── */
.qr-sticker-page {
  display: flex;
  flex-direction: column;
  height: 100dvh;
  overflow: hidden;
  font-family: 'Noto Sans KR', sans-serif;
}

.qr-sticker-page *,
.qr-sticker-page *::before,
.qr-sticker-page *::after {
  box-sizing: border-box;
}

/* 글로벌 min-height: 60px 오버라이드 (App.css) */
.qr-sticker-page button,
.qr-sticker-page select {
  min-height: auto;
}

/* ─── 헤더 ─── */
.qr-sticker-page .page-header {
  display: flex;
  align-items: center;
  padding: 6px 16px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  z-index: 10;
  flex-shrink: 0;
}

.qr-sticker-page .btn-back {
  background: none;
  border: none;
  font-size: 18px;
  color: #555;
  cursor: pointer;
  padding: 6px 10px;
  font-family: 'Noto Sans KR', sans-serif;
}

.qr-sticker-page .page-header-title {
  flex: 1 1;
  text-align: center;
  cursor: pointer;
  font-family: 'Jua', sans-serif;
  font-size: 20px;
  color: #2E7D32;
  margin: 0;
}

.header-store-name {
  font-size: 13px;
  color: #7B1FA2;
  background: #F3E5F5;
  border: 1px solid #CE93D8;
  border-radius: 16px;
  padding: 3px 12px;
  white-space: nowrap;
  flex-shrink: 0;
}

/* ─── 메인 콘텐츠: 좌우 2분할 ─── */
.sticker-content {
  flex: 1 1;
  display: flex;
  flex-direction: row;
  overflow: hidden;
  min-height: 0;
}

/* ═══════════════════════════════════
   QR스티커(자동) 리더 페이지 메인
   ═══════════════════════════════════ */
.reader-content {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  padding: 32px 24px;
  background: linear-gradient(170deg, #FFF8E1 0%, #FFECB3 40%, #FFE0B2 100%);
  overflow-y: auto;
  min-height: 0;
}

.reader-card {
  background: white;
  border-radius: 28px;
  padding: 48px 56px;
  text-align: center;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.10);
  border: 3px solid #FFCA28;
  max-width: 560px;
  width: 100%;
}

.reader-card-icon {
  display: block;
  font-size: 96px;
  line-height: 1;
  margin-bottom: 16px;
  animation: readerPulse 2.4s ease-in-out infinite;
}

@keyframes readerPulse {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.06); }
}

.reader-card-title {
  font-family: 'Jua', sans-serif;
  font-size: 32px;
  color: #5D4037;
  margin: 0 0 10px;
  font-weight: 400;
}

.reader-card-subtitle {
  font-family: 'Noto Sans KR', sans-serif;
  font-size: 18px;
  color: #8D6E63;
  margin: 0 0 24px;
}

.reader-card-status {
  display: inline-block;
  padding: 12px 32px;
  border-radius: 999px;
  font-family: 'Jua', sans-serif;
  font-size: 22px;
  background: #E8F5E9;
  color: #2E7D32;
  border: 2px solid #A5D6A7;
}

.reader-card-status.is-printing {
  background: #FFF3E0;
  color: #E65100;
  border-color: #FFB74D;
  animation: readerStatusBlink 1s ease-in-out infinite;
}

@keyframes readerStatusBlink {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.55; }
}

.reader-logs {
  width: 100%;
  max-width: 560px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

/* ═══════════════════════════════════
   좌측 패널 (40%) - QR 스캐너
   ═══════════════════════════════════ */
.sticker-left-panel {
  width: 40%;
  display: flex;
  flex-direction: column;
  background: linear-gradient(180deg, #1B5E20 0%, #2E7D32 50%, #1565C0 100%);
  border-right: 3px solid #0D47A1;
  position: relative;
}

.sticker-left-header {
  padding: 12px 16px;
  text-align: center;
  background: rgba(0, 0, 0, 0.15);
}

.sticker-left-header h2 {
  font-family: 'Jua', sans-serif;
  font-size: 22px;
  font-weight: 400;
  color: #fff;
  margin: 0;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

/* QR 스캐너 영역 */
.sticker-scanner-area {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 12px;
  min-height: 0;
  position: relative;
}

.sticker-scanner-area .qr-scanner {
  width: 100%;
  max-width: 360px;
  display: flex;
  flex-direction: column;
  align-items: center;
  max-height: none;
}

.sticker-scanner-area .qr-scanner-viewport {
  width: 100%;
  height: auto;
  aspect-ratio: 1;
  border-radius: 16px;
  overflow: hidden;
}

.sticker-scanner-area .qr-scanner-viewport video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.sticker-scanner-area .qr-scanner-guide {
  color: rgba(255, 255, 255, 0.8);
  font-family: 'Noto Sans KR', sans-serif;
  font-size: 16px;
  margin-top: 8px;
  writing-mode: horizontal-tb;
}

.sticker-scanner-area .qr-scanner-error {
  aspect-ratio: auto;
  height: auto;
}

.sticker-scan-guide {
  font-family: 'Noto Sans KR', sans-serif;
  font-size: 15px;
  color: rgba(255, 255, 255, 0.8);
  text-align: center;
  margin: 10px 0 0;
  line-height: 1.5;
  padding: 0 12px;
}

/* 출력 중 오버레이 (좌측 패널 위) */
.sticker-printing-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 20px;
  gap: 12px;
  z-index: 5;
}

.printing-spinner {
  width: 48px;
  height: 48px;
  border: 4px solid rgba(255,255,255,0.3);
  border-top-color: white;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

/* ═══════════════════════════════════
   우측 패널 (60%) - 전화번호 + 가족 + 로그
   ═══════════════════════════════════ */
.sticker-right-panel {
  width: 60%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: linear-gradient(170deg, #FFF8E1 0%, #FFECB3 40%, #FFE0B2 100%);
  padding: 12px 16px;
  position: relative;
}

/* 전화번호 입력 섹션 */
.phone-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
}

.phone-section-title {
  font-family: 'Jua', sans-serif;
  font-size: 18px;
  color: #5D4037;
  margin: 0 0 4px;
  text-align: center;
}

.phone-display {
  background: white;
  border-radius: 12px;
  padding: 8px 20px;
  font-size: 24px;
  font-weight: bold;
  text-align: center;
  width: 100%;
  max-width: 340px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  font-family: 'Jua', sans-serif;
  color: #333;
}

.phone-display .placeholder {
  color: #ccc;
}

.numpad {
  width: 100%;
  max-width: 340px;
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.numpad-row {
  display: flex;
  gap: 5px;
}

.numpad-key {
  flex: 1 1;
  padding: 10px;
  font-size: 20px;
  font-family: 'Jua', sans-serif;
  border: none;
  border-radius: 10px;
  background: white;
  color: #333;
  cursor: pointer;
  box-shadow: 0 2px 4px rgba(0,0,0,0.08);
  min-height: 42px;
}

.numpad-key:active {
  background: #E8F5E9;
}

.numpad-key.key-clear {
  background: #FFF3E0;
  color: #E65100;
}

.numpad-key.key-backspace {
  background: #FFEBEE;
  color: #D32F2F;
}

.btn-phone-search {
  width: 100%;
  max-width: 340px;
  padding: 10px;
  font-size: 18px;
  font-family: 'Jua', sans-serif;
  border: none;
  border-radius: 10px;
  background: #2E7D32;
  color: white;
  cursor: pointer;
  margin-top: 2px;
}

.btn-phone-search:disabled {
  background: #ccc;
  cursor: default;
}

.phone-error {
  color: #D32F2F;
  font-size: 16px;
  text-align: center;
}

/* 로딩 */
.loading-area {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 30px;
  gap: 12px;
  color: #666;
  font-size: 18px;
}

.loading-area .printing-spinner {
  border-color: rgba(46,125,50,0.2);
  border-top-color: #2E7D32;
}

/* ─── 가족 선택 섹션 ─── */
.family-section {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-height: 0;
  overflow: hidden;
}

.family-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
}

.family-count {
  font-size: 18px;
  font-weight: bold;
  color: #333;
}

.family-actions {
  display: flex;
  gap: 8px;
}

.btn-select-all {
  padding: 5px 12px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 8px;
  background: white;
  cursor: pointer;
  font-family: 'Noto Sans KR', sans-serif;
}

.family-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
  overflow-y: auto;
  flex: 1 1;
  min-height: 0;
}

.family-card {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
  background: white;
  border: 2px solid #eee;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.15s;
  font-family: 'Noto Sans KR', sans-serif;
  font-size: 17px;
  flex-shrink: 0;
}

.family-card.selected {
  border-color: #2E7D32;
  background: #E8F5E9;
}

.family-check {
  font-size: 20px;
  flex-shrink: 0;
}

.family-name {
  flex: 1 1;
  font-weight: bold;
  color: #333;
}

.family-type {
  font-size: 13px;
  color: #888;
  padding: 3px 10px;
  background: #f5f5f5;
  border-radius: 8px;
}

.family-buttons {
  display: flex;
  gap: 10px;
  flex-shrink: 0;
}

.btn-family-print {
  flex: 1 1;
  padding: 14px;
  font-size: 20px;
  font-family: 'Jua', sans-serif;
  border: none;
  border-radius: 12px;
  background: #2E7D32;
  color: white;
  cursor: pointer;
}

.btn-family-print:disabled {
  background: #ccc;
  cursor: default;
}

.btn-family-reset {
  padding: 14px 20px;
  font-size: 16px;
  font-family: 'Noto Sans KR', sans-serif;
  border: 1px solid #ccc;
  border-radius: 12px;
  background: white;
  cursor: pointer;
}

/* ─── 출력 로그 ─── */
.print-logs {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: auto;
  padding-top: 8px;
  border-top: 1px solid rgba(0,0,0,0.08);
}

.print-log {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  background: white;
  border-radius: 10px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.06);
  animation: slideIn 0.3s ease-out;
}

@keyframes slideIn {
  from { opacity: 0; transform: translateY(-10px); }
  to { opacity: 1; transform: translateY(0); }
}

.print-log.success {
  border-left: 4px solid #4CAF50;
}

.print-log.error {
  border-left: 4px solid #F44336;
}

.log-icon {
  font-size: 18px;
  flex-shrink: 0;
}

.log-message {
  flex: 1 1;
  font-size: 15px;
  color: #333;
}

.log-time {
  font-size: 13px;
  color: #999;
  flex-shrink: 0;
}

/* ─── 프린터 상태 바 ─── */
.printer-status-bar {
  flex-shrink: 0;
  padding: 8px 20px;
  background: white;
  text-align: center;
  font-size: 15px;
  color: #666;
  box-shadow: 0 -2px 8px rgba(0,0,0,0.06);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
}

.printer-select {
  padding: 5px 10px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 8px;
  background: white;
  font-family: 'Noto Sans KR', sans-serif;
}

/* ─── 프린터 에러 오버레이 ─── */
.printer-error-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
}

.printer-error-card {
  background: white;
  border-radius: 24px;
  padding: 40px;
  text-align: center;
  max-width: 400px;
  box-shadow: 0 8px 32px rgba(0,0,0,0.2);
}

.printer-error-icon {
  font-size: 56px;
  display: block;
  margin-bottom: 12px;
}

.printer-error-card h2 {
  font-family: 'Jua', sans-serif;
  font-size: 26px;
  color: #D32F2F;
  margin: 0 0 10px;
}

.printer-error-card p {
  font-size: 18px;
  color: #555;
  margin: 0 0 8px;
}

.printer-error-info {
  margin: 14px 0;
  padding: 10px;
  background: #f5f5f5;
  border-radius: 12px;
  font-size: 15px;
  color: #666;
}

.printer-error-info p {
  margin: 4px 0;
  font-size: 14px;
}

.printer-error-buttons {
  display: flex;
  gap: 10px;
  margin-top: 16px;
}

.btn-printer-retry {
  flex: 1 1;
  padding: 12px;
  font-size: 17px;
  font-family: 'Noto Sans KR', sans-serif;
  border: none;
  border-radius: 12px;
  background: #2E7D32;
  color: white;
  cursor: pointer;
}

.btn-printer-dismiss {
  flex: 1 1;
  padding: 12px;
  font-size: 17px;
  font-family: 'Noto Sans KR', sans-serif;
  border: 1px solid #ccc;
  border-radius: 12px;
  background: white;
  color: #555;
  cursor: pointer;
}

/* ─── 우측 패널 구분선 (가족 데이터 있을 때) ─── */
.right-divider {
  height: 1px;
  background: rgba(0,0,0,0.08);
  margin: 4px 0;
  flex-shrink: 0;
}

/* ═══ 가족 선택 팝업 (우측 패널 오버레이) ═══ */
.family-popup-overlay {
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 20;
  padding: 16px;
}

.family-popup {
  background: white;
  border-radius: 20px;
  padding: 20px;
  width: 100%;
  max-width: 420px;
  max-height: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.25);
  animation: popupSlideUp 0.25s ease-out;
}

@keyframes popupSlideUp {
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
}

.family-popup-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 8px;
  border-bottom: 2px solid #E8F5E9;
}

.family-popup-member-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.family-popup-name {
  font-family: 'Jua', sans-serif;
  font-size: 22px;
  color: #2E7D32;
}

.family-popup-phone {
  font-size: 14px;
  color: #888;
}

.family-popup-badge {
  font-family: 'Jua', sans-serif;
  font-size: 15px;
  color: #5D4037;
  background: #FFF8E1;
  border: 1px solid #FFCA28;
  border-radius: 12px;
  padding: 4px 12px;
  white-space: nowrap;
}

.family-popup-toggle {
  display: flex;
  justify-content: flex-end;
}

.btn-toggle-all {
  padding: 6px 14px;
  font-size: 14px;
  font-family: 'Noto Sans KR', sans-serif;
  border: 1px solid #ccc;
  border-radius: 8px;
  background: #f9f9f9;
  cursor: pointer;
  color: #555;
}

.btn-toggle-all:active { background: #eee; }

.family-popup-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
  overflow-y: auto;
  max-height: 240px;
}

.family-popup-card {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 6px 16px;
  background: #f9f9f9;
  border: 2px solid #eee;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.15s;
  font-size: 17px;
  flex-shrink: 0;
}

.family-popup-card.selected {
  border-color: #2E7D32;
  background: #E8F5E9;
}

.family-popup-card:active { transform: scale(0.98); }

.family-popup-check { font-size: 22px; flex-shrink: 0; }
.family-popup-card-name { flex: 1 1; font-weight: bold; color: #333; }
.family-popup-card-type {
  font-size: 13px;
  color: #888;
  padding: 3px 10px;
  background: rgba(0, 0, 0, 0.04);
  border-radius: 8px;
}

.family-popup-error {
  color: #D32F2F;
  font-size: 15px;
  text-align: center;
  padding: 6px;
  background: #FFEBEE;
  border-radius: 8px;
}

.family-popup-actions {
  display: flex;
  gap: 10px;
}

.btn-popup-print {
  flex: 2 1;
  padding: 14px;
  font-size: 20px;
  font-family: 'Jua', sans-serif;
  border: none;
  border-radius: 14px;
  background: #2E7D32;
  color: white;
  cursor: pointer;
}

.btn-popup-print:disabled { background: #ccc; cursor: default; }
.btn-popup-print:active:not(:disabled) { background: #1B5E20; }

.btn-popup-cancel {
  flex: 1 1;
  padding: 14px;
  font-size: 16px;
  font-family: 'Noto Sans KR', sans-serif;
  border: 1px solid #ccc;
  border-radius: 14px;
  background: white;
  color: #555;
  cursor: pointer;
}

.btn-popup-cancel:active { background: #f5f5f5; }
`, "",{"version":3,"sources":["webpack://./src/pages/QrStickerPage.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF,oBAAoB;AACpB;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,gBAAgB;EAChB,uCAAuC;AACzC;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA,yCAAyC;AACzC;;EAEE,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,sCAAsC;EACtC,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,uCAAuC;AACzC;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,eAAe;EACf,8BAA8B;EAC9B,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;AACf;;AAEA;;wCAEwC;AACxC;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,0EAA0E;EAC1E,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,0CAA0C;EAC1C,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gDAAgD;AAClD;;AAEA;EACE,WAAW,mBAAmB,EAAE;EAChC,MAAM,sBAAsB,EAAE;AAChC;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;EACvC,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,oBAAoB;EACpB,8BAA8B;EAC9B,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,oDAAoD;AACtD;;AAEA;EACE,WAAW,UAAU,EAAE;EACvB,MAAM,aAAa,EAAE;AACvB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;;wCAEwC;AACxC;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,0EAA0E;EAC1E,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,SAAS;EACT,yCAAyC;AAC3C;;AAEA,cAAc;AACd;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;EAC/B,uCAAuC;EACvC,eAAe;EACf,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,uCAAuC;EACvC,eAAe;EACf,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uCAAuC;EACvC,uBAAuB;EACvB,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;;wCAEwC;AACxC;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,0EAA0E;EAC1E,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,sCAAsC;EACtC,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA,OAAO;AACP;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,iCAAiC;EACjC,yBAAyB;AAC3B;;AAEA,qBAAqB;AACrB;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,SAAO;EACP,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,qBAAqB;EACrB,uCAAuC;EACvC,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,uCAAuC;EACvC,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,sCAAsC;EACtC,gCAAgC;AAClC;;AAEA;EACE,OAAO,UAAU,EAAE,4BAA4B,EAAE;EACjD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,uCAAuC;EACvC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,uCAAuC;AACzC;;AAEA,wBAAwB;AACxB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,eAAe;EACf,uCAAuC;EACvC,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,eAAe;EACf,uCAAuC;EACvC,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,eAAe;AACjB;;AAEA,oCAAoC;AACpC;EACE,WAAW;EACX,4BAA4B;EAC5B,aAAa;EACb,cAAc;AAChB;;AAEA,kCAAkC;AAClC;EACE,kBAAkB;EAClB,MAAM,EAAE,OAAO,EAAE,QAAQ,EAAE,SAAS;EACpC,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,0CAA0C;EAC1C,sCAAsC;AACxC;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,uCAAuC;EACvC,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb;;AAEA,yBAAyB,gBAAgB,EAAE;;AAE3C;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,qBAAqB;EACrB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,4BAA4B,sBAAsB,EAAE;;AAEpD,sBAAsB,eAAe,EAAE,cAAc,EAAE;AACvD,0BAA0B,SAAO,EAAE,iBAAiB,EAAE,WAAW,EAAE;AACnE;EACE,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;EACP,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA,4BAA4B,gBAAgB,EAAE,eAAe,EAAE;AAC/D,yCAAyC,mBAAmB,EAAE;;AAE9D;EACE,SAAO;EACP,aAAa;EACb,eAAe;EACf,uCAAuC;EACvC,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,eAAe;AACjB;;AAEA,2BAA2B,mBAAmB,EAAE","sourcesContent":["/**\n * QR 스티커 출력 페이지 - 가로 2분할 레이아웃\n * 좌: QR 카메라 스캐너 (40%) / 우: 전화번호 + 가족 + 로그 (60%)\n */\n\n/* ─── 전체 레이아웃 ─── */\n.qr-sticker-page {\n  display: flex;\n  flex-direction: column;\n  height: 100dvh;\n  overflow: hidden;\n  font-family: 'Noto Sans KR', sans-serif;\n}\n\n.qr-sticker-page *,\n.qr-sticker-page *::before,\n.qr-sticker-page *::after {\n  box-sizing: border-box;\n}\n\n/* 글로벌 min-height: 60px 오버라이드 (App.css) */\n.qr-sticker-page button,\n.qr-sticker-page select {\n  min-height: auto;\n}\n\n/* ─── 헤더 ─── */\n.qr-sticker-page .page-header {\n  display: flex;\n  align-items: center;\n  padding: 6px 16px;\n  background: #fff;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.08);\n  z-index: 10;\n  flex-shrink: 0;\n}\n\n.qr-sticker-page .btn-back {\n  background: none;\n  border: none;\n  font-size: 18px;\n  color: #555;\n  cursor: pointer;\n  padding: 6px 10px;\n  font-family: 'Noto Sans KR', sans-serif;\n}\n\n.qr-sticker-page .page-header-title {\n  flex: 1;\n  text-align: center;\n  cursor: pointer;\n  font-family: 'Jua', sans-serif;\n  font-size: 20px;\n  color: #2E7D32;\n  margin: 0;\n}\n\n.header-store-name {\n  font-size: 13px;\n  color: #7B1FA2;\n  background: #F3E5F5;\n  border: 1px solid #CE93D8;\n  border-radius: 16px;\n  padding: 3px 12px;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n/* ─── 메인 콘텐츠: 좌우 2분할 ─── */\n.sticker-content {\n  flex: 1;\n  display: flex;\n  flex-direction: row;\n  overflow: hidden;\n  min-height: 0;\n}\n\n/* ═══════════════════════════════════\n   QR스티커(자동) 리더 페이지 메인\n   ═══════════════════════════════════ */\n.reader-content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 20px;\n  padding: 32px 24px;\n  background: linear-gradient(170deg, #FFF8E1 0%, #FFECB3 40%, #FFE0B2 100%);\n  overflow-y: auto;\n  min-height: 0;\n}\n\n.reader-card {\n  background: white;\n  border-radius: 28px;\n  padding: 48px 56px;\n  text-align: center;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.10);\n  border: 3px solid #FFCA28;\n  max-width: 560px;\n  width: 100%;\n}\n\n.reader-card-icon {\n  display: block;\n  font-size: 96px;\n  line-height: 1;\n  margin-bottom: 16px;\n  animation: readerPulse 2.4s ease-in-out infinite;\n}\n\n@keyframes readerPulse {\n  0%, 100% { transform: scale(1); }\n  50% { transform: scale(1.06); }\n}\n\n.reader-card-title {\n  font-family: 'Jua', sans-serif;\n  font-size: 32px;\n  color: #5D4037;\n  margin: 0 0 10px;\n  font-weight: 400;\n}\n\n.reader-card-subtitle {\n  font-family: 'Noto Sans KR', sans-serif;\n  font-size: 18px;\n  color: #8D6E63;\n  margin: 0 0 24px;\n}\n\n.reader-card-status {\n  display: inline-block;\n  padding: 12px 32px;\n  border-radius: 999px;\n  font-family: 'Jua', sans-serif;\n  font-size: 22px;\n  background: #E8F5E9;\n  color: #2E7D32;\n  border: 2px solid #A5D6A7;\n}\n\n.reader-card-status.is-printing {\n  background: #FFF3E0;\n  color: #E65100;\n  border-color: #FFB74D;\n  animation: readerStatusBlink 1s ease-in-out infinite;\n}\n\n@keyframes readerStatusBlink {\n  0%, 100% { opacity: 1; }\n  50% { opacity: 0.55; }\n}\n\n.reader-logs {\n  width: 100%;\n  max-width: 560px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n/* ═══════════════════════════════════\n   좌측 패널 (40%) - QR 스캐너\n   ═══════════════════════════════════ */\n.sticker-left-panel {\n  width: 40%;\n  display: flex;\n  flex-direction: column;\n  background: linear-gradient(180deg, #1B5E20 0%, #2E7D32 50%, #1565C0 100%);\n  border-right: 3px solid #0D47A1;\n  position: relative;\n}\n\n.sticker-left-header {\n  padding: 12px 16px;\n  text-align: center;\n  background: rgba(0, 0, 0, 0.15);\n}\n\n.sticker-left-header h2 {\n  font-family: 'Jua', sans-serif;\n  font-size: 22px;\n  font-weight: 400;\n  color: #fff;\n  margin: 0;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n}\n\n/* QR 스캐너 영역 */\n.sticker-scanner-area {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 12px;\n  min-height: 0;\n  position: relative;\n}\n\n.sticker-scanner-area .qr-scanner {\n  width: 100%;\n  max-width: 360px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  max-height: none;\n}\n\n.sticker-scanner-area .qr-scanner-viewport {\n  width: 100%;\n  height: auto;\n  aspect-ratio: 1;\n  border-radius: 16px;\n  overflow: hidden;\n}\n\n.sticker-scanner-area .qr-scanner-viewport video {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.sticker-scanner-area .qr-scanner-guide {\n  color: rgba(255, 255, 255, 0.8);\n  font-family: 'Noto Sans KR', sans-serif;\n  font-size: 16px;\n  margin-top: 8px;\n  writing-mode: horizontal-tb;\n}\n\n.sticker-scanner-area .qr-scanner-error {\n  aspect-ratio: auto;\n  height: auto;\n}\n\n.sticker-scan-guide {\n  font-family: 'Noto Sans KR', sans-serif;\n  font-size: 15px;\n  color: rgba(255, 255, 255, 0.8);\n  text-align: center;\n  margin: 10px 0 0;\n  line-height: 1.5;\n  padding: 0 12px;\n}\n\n/* 출력 중 오버레이 (좌측 패널 위) */\n.sticker-printing-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.6);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  font-size: 20px;\n  gap: 12px;\n  z-index: 5;\n}\n\n.printing-spinner {\n  width: 48px;\n  height: 48px;\n  border: 4px solid rgba(255,255,255,0.3);\n  border-top-color: white;\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n\n/* ═══════════════════════════════════\n   우측 패널 (60%) - 전화번호 + 가족 + 로그\n   ═══════════════════════════════════ */\n.sticker-right-panel {\n  width: 60%;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  background: linear-gradient(170deg, #FFF8E1 0%, #FFECB3 40%, #FFE0B2 100%);\n  padding: 12px 16px;\n  position: relative;\n}\n\n/* 전화번호 입력 섹션 */\n.phone-section {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 6px;\n  flex-shrink: 0;\n}\n\n.phone-section-title {\n  font-family: 'Jua', sans-serif;\n  font-size: 18px;\n  color: #5D4037;\n  margin: 0 0 4px;\n  text-align: center;\n}\n\n.phone-display {\n  background: white;\n  border-radius: 12px;\n  padding: 8px 20px;\n  font-size: 24px;\n  font-weight: bold;\n  text-align: center;\n  width: 100%;\n  max-width: 340px;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.08);\n  font-family: 'Jua', sans-serif;\n  color: #333;\n}\n\n.phone-display .placeholder {\n  color: #ccc;\n}\n\n.numpad {\n  width: 100%;\n  max-width: 340px;\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n\n.numpad-row {\n  display: flex;\n  gap: 5px;\n}\n\n.numpad-key {\n  flex: 1;\n  padding: 10px;\n  font-size: 20px;\n  font-family: 'Jua', sans-serif;\n  border: none;\n  border-radius: 10px;\n  background: white;\n  color: #333;\n  cursor: pointer;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.08);\n  min-height: 42px;\n}\n\n.numpad-key:active {\n  background: #E8F5E9;\n}\n\n.numpad-key.key-clear {\n  background: #FFF3E0;\n  color: #E65100;\n}\n\n.numpad-key.key-backspace {\n  background: #FFEBEE;\n  color: #D32F2F;\n}\n\n.btn-phone-search {\n  width: 100%;\n  max-width: 340px;\n  padding: 10px;\n  font-size: 18px;\n  font-family: 'Jua', sans-serif;\n  border: none;\n  border-radius: 10px;\n  background: #2E7D32;\n  color: white;\n  cursor: pointer;\n  margin-top: 2px;\n}\n\n.btn-phone-search:disabled {\n  background: #ccc;\n  cursor: default;\n}\n\n.phone-error {\n  color: #D32F2F;\n  font-size: 16px;\n  text-align: center;\n}\n\n/* 로딩 */\n.loading-area {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 30px;\n  gap: 12px;\n  color: #666;\n  font-size: 18px;\n}\n\n.loading-area .printing-spinner {\n  border-color: rgba(46,125,50,0.2);\n  border-top-color: #2E7D32;\n}\n\n/* ─── 가족 선택 섹션 ─── */\n.family-section {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  min-height: 0;\n  overflow: hidden;\n}\n\n.family-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-shrink: 0;\n}\n\n.family-count {\n  font-size: 18px;\n  font-weight: bold;\n  color: #333;\n}\n\n.family-actions {\n  display: flex;\n  gap: 8px;\n}\n\n.btn-select-all {\n  padding: 5px 12px;\n  font-size: 14px;\n  border: 1px solid #ccc;\n  border-radius: 8px;\n  background: white;\n  cursor: pointer;\n  font-family: 'Noto Sans KR', sans-serif;\n}\n\n.family-list {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  overflow-y: auto;\n  flex: 1;\n  min-height: 0;\n}\n\n.family-card {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 12px 14px;\n  background: white;\n  border: 2px solid #eee;\n  border-radius: 12px;\n  cursor: pointer;\n  transition: all 0.15s;\n  font-family: 'Noto Sans KR', sans-serif;\n  font-size: 17px;\n  flex-shrink: 0;\n}\n\n.family-card.selected {\n  border-color: #2E7D32;\n  background: #E8F5E9;\n}\n\n.family-check {\n  font-size: 20px;\n  flex-shrink: 0;\n}\n\n.family-name {\n  flex: 1;\n  font-weight: bold;\n  color: #333;\n}\n\n.family-type {\n  font-size: 13px;\n  color: #888;\n  padding: 3px 10px;\n  background: #f5f5f5;\n  border-radius: 8px;\n}\n\n.family-buttons {\n  display: flex;\n  gap: 10px;\n  flex-shrink: 0;\n}\n\n.btn-family-print {\n  flex: 1;\n  padding: 14px;\n  font-size: 20px;\n  font-family: 'Jua', sans-serif;\n  border: none;\n  border-radius: 12px;\n  background: #2E7D32;\n  color: white;\n  cursor: pointer;\n}\n\n.btn-family-print:disabled {\n  background: #ccc;\n  cursor: default;\n}\n\n.btn-family-reset {\n  padding: 14px 20px;\n  font-size: 16px;\n  font-family: 'Noto Sans KR', sans-serif;\n  border: 1px solid #ccc;\n  border-radius: 12px;\n  background: white;\n  cursor: pointer;\n}\n\n/* ─── 출력 로그 ─── */\n.print-logs {\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  margin-top: auto;\n  padding-top: 8px;\n  border-top: 1px solid rgba(0,0,0,0.08);\n}\n\n.print-log {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 12px;\n  background: white;\n  border-radius: 10px;\n  box-shadow: 0 2px 6px rgba(0,0,0,0.06);\n  animation: slideIn 0.3s ease-out;\n}\n\n@keyframes slideIn {\n  from { opacity: 0; transform: translateY(-10px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n.print-log.success {\n  border-left: 4px solid #4CAF50;\n}\n\n.print-log.error {\n  border-left: 4px solid #F44336;\n}\n\n.log-icon {\n  font-size: 18px;\n  flex-shrink: 0;\n}\n\n.log-message {\n  flex: 1;\n  font-size: 15px;\n  color: #333;\n}\n\n.log-time {\n  font-size: 13px;\n  color: #999;\n  flex-shrink: 0;\n}\n\n/* ─── 프린터 상태 바 ─── */\n.printer-status-bar {\n  flex-shrink: 0;\n  padding: 8px 20px;\n  background: white;\n  text-align: center;\n  font-size: 15px;\n  color: #666;\n  box-shadow: 0 -2px 8px rgba(0,0,0,0.06);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n}\n\n.printer-select {\n  padding: 5px 10px;\n  font-size: 14px;\n  border: 1px solid #ccc;\n  border-radius: 8px;\n  background: white;\n  font-family: 'Noto Sans KR', sans-serif;\n}\n\n/* ─── 프린터 에러 오버레이 ─── */\n.printer-error-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0,0,0,0.7);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 100;\n}\n\n.printer-error-card {\n  background: white;\n  border-radius: 24px;\n  padding: 40px;\n  text-align: center;\n  max-width: 400px;\n  box-shadow: 0 8px 32px rgba(0,0,0,0.2);\n}\n\n.printer-error-icon {\n  font-size: 56px;\n  display: block;\n  margin-bottom: 12px;\n}\n\n.printer-error-card h2 {\n  font-family: 'Jua', sans-serif;\n  font-size: 26px;\n  color: #D32F2F;\n  margin: 0 0 10px;\n}\n\n.printer-error-card p {\n  font-size: 18px;\n  color: #555;\n  margin: 0 0 8px;\n}\n\n.printer-error-info {\n  margin: 14px 0;\n  padding: 10px;\n  background: #f5f5f5;\n  border-radius: 12px;\n  font-size: 15px;\n  color: #666;\n}\n\n.printer-error-info p {\n  margin: 4px 0;\n  font-size: 14px;\n}\n\n.printer-error-buttons {\n  display: flex;\n  gap: 10px;\n  margin-top: 16px;\n}\n\n.btn-printer-retry {\n  flex: 1;\n  padding: 12px;\n  font-size: 17px;\n  font-family: 'Noto Sans KR', sans-serif;\n  border: none;\n  border-radius: 12px;\n  background: #2E7D32;\n  color: white;\n  cursor: pointer;\n}\n\n.btn-printer-dismiss {\n  flex: 1;\n  padding: 12px;\n  font-size: 17px;\n  font-family: 'Noto Sans KR', sans-serif;\n  border: 1px solid #ccc;\n  border-radius: 12px;\n  background: white;\n  color: #555;\n  cursor: pointer;\n}\n\n/* ─── 우측 패널 구분선 (가족 데이터 있을 때) ─── */\n.right-divider {\n  height: 1px;\n  background: rgba(0,0,0,0.08);\n  margin: 4px 0;\n  flex-shrink: 0;\n}\n\n/* ═══ 가족 선택 팝업 (우측 패널 오버레이) ═══ */\n.family-popup-overlay {\n  position: absolute;\n  top: 0; left: 0; right: 0; bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 20;\n  padding: 16px;\n}\n\n.family-popup {\n  background: white;\n  border-radius: 20px;\n  padding: 20px;\n  width: 100%;\n  max-width: 420px;\n  max-height: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.25);\n  animation: popupSlideUp 0.25s ease-out;\n}\n\n@keyframes popupSlideUp {\n  from { opacity: 0; transform: translateY(20px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n.family-popup-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-bottom: 8px;\n  border-bottom: 2px solid #E8F5E9;\n}\n\n.family-popup-member-info {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.family-popup-name {\n  font-family: 'Jua', sans-serif;\n  font-size: 22px;\n  color: #2E7D32;\n}\n\n.family-popup-phone {\n  font-size: 14px;\n  color: #888;\n}\n\n.family-popup-badge {\n  font-family: 'Jua', sans-serif;\n  font-size: 15px;\n  color: #5D4037;\n  background: #FFF8E1;\n  border: 1px solid #FFCA28;\n  border-radius: 12px;\n  padding: 4px 12px;\n  white-space: nowrap;\n}\n\n.family-popup-toggle {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.btn-toggle-all {\n  padding: 6px 14px;\n  font-size: 14px;\n  font-family: 'Noto Sans KR', sans-serif;\n  border: 1px solid #ccc;\n  border-radius: 8px;\n  background: #f9f9f9;\n  cursor: pointer;\n  color: #555;\n}\n\n.btn-toggle-all:active { background: #eee; }\n\n.family-popup-list {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  overflow-y: auto;\n  max-height: 240px;\n}\n\n.family-popup-card {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 6px 16px;\n  background: #f9f9f9;\n  border: 2px solid #eee;\n  border-radius: 12px;\n  cursor: pointer;\n  transition: all 0.15s;\n  font-size: 17px;\n  flex-shrink: 0;\n}\n\n.family-popup-card.selected {\n  border-color: #2E7D32;\n  background: #E8F5E9;\n}\n\n.family-popup-card:active { transform: scale(0.98); }\n\n.family-popup-check { font-size: 22px; flex-shrink: 0; }\n.family-popup-card-name { flex: 1; font-weight: bold; color: #333; }\n.family-popup-card-type {\n  font-size: 13px;\n  color: #888;\n  padding: 3px 10px;\n  background: rgba(0, 0, 0, 0.04);\n  border-radius: 8px;\n}\n\n.family-popup-error {\n  color: #D32F2F;\n  font-size: 15px;\n  text-align: center;\n  padding: 6px;\n  background: #FFEBEE;\n  border-radius: 8px;\n}\n\n.family-popup-actions {\n  display: flex;\n  gap: 10px;\n}\n\n.btn-popup-print {\n  flex: 2;\n  padding: 14px;\n  font-size: 20px;\n  font-family: 'Jua', sans-serif;\n  border: none;\n  border-radius: 14px;\n  background: #2E7D32;\n  color: white;\n  cursor: pointer;\n}\n\n.btn-popup-print:disabled { background: #ccc; cursor: default; }\n.btn-popup-print:active:not(:disabled) { background: #1B5E20; }\n\n.btn-popup-cancel {\n  flex: 1;\n  padding: 14px;\n  font-size: 16px;\n  font-family: 'Noto Sans KR', sans-serif;\n  border: 1px solid #ccc;\n  border-radius: 14px;\n  background: white;\n  color: #555;\n  cursor: pointer;\n}\n\n.btn-popup-cancel:active { background: #f5f5f5; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
